<div class="loader-container" *ngIf="loading === true">
    <div class="spinner"></div>
    <p>Carregando...</p>
</div>